



















import { Component, Vue } from "vue-property-decorator";

// Enums
import { DataModules } from "@/store/modules/data";
import { ActionTypes } from "@/data/enums";
import { CustomFieldsMajorTypes } from "@/data/enums/customFields";

@Component({
  components: {
    "manage-custom-fields": () =>
      import("@/components/app/admin/customFields/manageCustomFields.vue")
  }
})
export default class BasketCustomFieldSettings extends Vue {
  public customFieldsType = CustomFieldsMajorTypes.BASKET;

  public get i18n() {
    return {
      title: this.$t("_.basket_custom_fields"),
      cta: this.$t("_action.create_object", {
        object: (this.$t("_.custom_field") as string).toLowerCase()
      })
    };
  }

  public openManageCustomFieldModal() {
    if (this.canCreateCustomField) {
      this.$store.dispatch(
        `data/${DataModules.CUSTOM_FIELDS}/openManageCustomFieldModal`,
        {
          props: {
            customFieldType: this.customFieldsType,
            actionType: ActionTypes.CREATE
          }
        }
      );
    }
  }

  public get canCreateCustomField() {
    return this.$userCan("create_basket_field");
  }
}
